/**
 * Delivery line under the share size buttons (snippets/yf-share-value.liquid):
 * "Delivery from $15" or "Free delivery", following the variant chosen.
 *
 * Liquid works out, per variant, whether what the shopper pays clears the
 * free delivery threshold (script[data-yf-free-by-variant]); this only swaps
 * the text. Variant changes: Concept's variant:change on the product form
 * (non-bubbling, so caught on the way down), plus the form's id input as a
 * fallback for re-renders that skip the event.
 */
(function () {
  'use strict';
  if (window.__yfShareValueReady) return;
  window.__yfShareValueReady = true;

  function freeMap(root) {
    if (root.__yfFree) return root.__yfFree;
    var el = root.querySelector('script[data-yf-free-by-variant]');
    try { root.__yfFree = el ? JSON.parse(el.textContent || '{}') : {}; } catch (e) { root.__yfFree = {}; }
    return root.__yfFree;
  }

  function currentVariantId(root) {
    var form = document.getElementById(root.getAttribute('data-form'));
    var input = form && form.querySelector('[name="id"]');
    return input ? input.value : null;
  }

  // The line renders in the block, below the whole picker. Move it to just
  // under the first option (Size), where the choice is made. The block keeps
  // a reference, so if Concept redraws the picker the line goes back in.
  function place(root, line) {
    var form = document.getElementById(root.getAttribute('data-form'));
    var scope = (form && (form.closest('.shopify-section') || form.closest('quick-view'))) || document;
    var first = scope.querySelector('variant-picker fieldset[data-option-index="option1"]');
    if (!first) {
      if (!line.isConnected) root.insertBefore(line, root.firstChild);
      return;
    }
    if (first.nextElementSibling !== line) first.insertAdjacentElement('afterend', line);
  }

  function update(root, variantId) {
    var line = root.__yfLine || (root.__yfLine = root.querySelector('.yf-share-value__delivery'));
    if (!line) return;
    place(root, line);
    var text = line.querySelector('[data-yf-delivery-text]');
    if (!text || !variantId) return;
    var free = freeMap(root)[String(variantId)];
    if (free === undefined) return;
    line.classList.toggle('is-free', free);
    var next = free ? text.getAttribute('data-free') : text.getAttribute('data-paid');
    if (text.textContent !== next) text.textContent = next;
  }

  function updateAll(variantId) {
    document.querySelectorAll('[data-yf-share-value]').forEach(function (root) {
      try { update(root, variantId || currentVariantId(root)); } catch (e) {}
    });
  }

  document.addEventListener('variant:change', function (e) {
    var v = e.detail && e.detail.variant;
    updateAll(v && v.id);
    setTimeout(function () { updateAll(v && v.id); }, 80);
  }, true);

  // Option clicks: the form's id input changes a moment after the radio.
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('variant-picker')) {
      setTimeout(function () { updateAll(); }, 60);
    }
  }, true);

  updateAll();
})();
